module.exports = __webpack_public_path__ + "c09690a6.svg";